export const FORM_COMMENT_SPACING = {
  NONE: 'none',
  MEDIUM: 'medium'
}
export const BASE_CLASS = 'mt-FormComment'
export const HEADING_BASE_CLASS = `${BASE_CLASS}-heading`
